export enum JobBookingStatus {
  Unassigned = 'Unassigned',
  Pencilled = 'Pencilled',
  PencilAccepted = 'PencilAccepted',
  Booked = 'Booked',
  Confirmed = 'Confirmed',
}

export const JobBookingStatuses = Object.values(JobBookingStatus);

export const JobBookingStatusHubLocked = [
  JobBookingStatus.Pencilled,
  JobBookingStatus.Booked,
  JobBookingStatus.Confirmed,
];

export const JobBookingStatusCrewActionable = [
  JobBookingStatus.Booked,
  JobBookingStatus.Pencilled,
];
